
export const environment = {
  production: false,
  apiUrl: 'http://localhost:3300/api'
  // apiUrl: 'https://dev.mercosys.com.py/agrofuturo/api'
};
